import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseRowSchema } from './shapes';

export const CommitReleaseSchema = ReleaseRowSchema.pick({
  id: true,
  productId: true,
  productSlug: true,
  productName: true,
  environment: true,
  version: true,
  buildNumber: true,
  status: true,
});
export type CommitRelease = z.infer<typeof CommitReleaseSchema>;

export const CommitWithReleasesSchema = z.object({
  sha: z.string(),
  subject: z.string(),
  url: z.string(),
  authorLogin: z.string().nullable(),
  authorId: z.number().nullable(),
  releases: z.array(CommitReleaseSchema),
});
export type CommitWithReleases = z.infer<typeof CommitWithReleasesSchema>;

/**
 * Which confirmed releases contain a commit. Accepts a full SHA or a ≥7-char
 * hex prefix (which may match several commits, and — without productId —
 * commits across products). Membership comes from the Confirm-frozen snapshot.
 */
export const getReleasesByCommit = defineEndpoint({
  method: 'GET',
  path: '/v1/releases/by-commit',
  params: z.object({}),
  query: z.object({
    sha: z.string().regex(/^[0-9a-fA-F]{7,40}$/, 'must be a 7-40 char hex SHA (prefix ok)'),
    productId: z.string().uuid().optional(),
  }),
  body: z.undefined(),
  response: z.object({ data: z.array(CommitWithReleasesSchema) }),
});
